module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/_olympics-ebb5001786a4e3cf4550b3f5b3399373.png";